import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import moment from 'moment';
import { isMobile, isTabletOrLess } from 'utils/isMobile';

// Input feedback
const InputFeedback = ({ error }) => (error ? <div>{error}</div> : null);

const styles = {
	groupGender: {
		//width: '100%',
		//display: 'flex',
		flexWrap: 'wrap',
	},
	labelGroupGender: {
		fontSize: '1em',
		marginBottom: 10,
		fontWeight: 600,
		marginTop: 5,
		marginLeft: 2,
		width: '90%',
	},
	radioGroupGender: {
		width: isMobile() ? '100%' : isTabletOrLess() ? '50%' : '33%',
		display: 'flex',
		flex: 1,
		flexBasis: isMobile() ? '100%' : isTabletOrLess() ? '50%' : '33%',
	},
	inputStyle: {
		width: '100%',
	},
	inputContainer: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
	},
	records: {
		position: 'absolute',
		right: 0,
	},
	crossRequired: {
		color: '#c5190e',
		fontSize: '1em',
		position: 'relative',
		bottom: 4,
		left: 4,
	},
};

const Records = ({ records, onClick, disabled }) => (
	<Dropdown
		closeOnEscape
		closeOnChange
		icon='file alternate outline'
		direction='right'
		className='largegreenIcon'
		style={styles.records}
		disabled={disabled}
	>
		<Dropdown.Menu direction='left'>
			<Dropdown.Header icon='folder outline' content='Antécédants' />
			<Dropdown.Divider />
			{records.map((r, i) => {
				return (
					<Dropdown.Item
						key={r.label + ' ' + r.value + i}
						description={moment(r.created_at).format(
							`${process.env.REACT_APP_DATE_DISPLAY_FORMAT}, ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`
						)}
						onClick={(e) => {
							if (e !== undefined) e.preventDefault();
							onClick(r.value);
						}}
						text={String(r.label)}
					/>
				);
			})}
		</Dropdown.Menu>
	</Dropdown>
);

// Checkbox group
export default class CheckboxGroup extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			possibleValues: [],
		};
	}

	handleChange = (event) => {

		const target = event.currentTarget.firstChild;
		let valueArray = this.props.value.slice();
		let index = valueArray.indexOf(target.name)
		if (index > -1) {
			valueArray.splice(index, 1);
		} else {
			valueArray.push(target.name);
		}
		this.props.onChange(this.props.id, valueArray, false);
	};

	handleBlur = () => {
		// take care of touched
		this.props.onBlur(this.props.id, true, false); // false arg tells formik not to run validation now, because we are doing validation on FolderManager index (https://github.com/jaredpalmer/formik/issues/1209)
		if (this.props.prevalidfolders)
			this.props.prevalidfolders();
	};

	setRecordValue = (value) => {
		let possibleValues = this.props.possibleValues.map(
			(i) => i.answer_option.label
		);
		let index = value.findIndex((i) => !possibleValues.includes(i));

		if (index > -1) {
			// from free input
			let fromFreeInputValue = value[index];

			// Set up freeInput
			this.props.onChange(this.props.id + 'freeInput', fromFreeInputValue);
			value.splice(index, 1, 'freeInput');

			this.props.onChange(this.props.id, value);
		} else {
			this.props.onChange(this.props.id, value);
		}
	};

	render() {
		const { value, error, touched, label, children, required, disabled } = this.props;

		return (
			<div>
				<div style={styles.groupGender}>
					<div style={styles.labelGroupGender}>
						{label}
						{required && <span style={styles.crossRequired}>*</span>}
						{this.props.records.length > 0 && (
							<Records
								records={this.props.records}
								onClick={(value) => {
									this.setRecordValue(value);
								}}
								disabled={disabled}
							/>
						)}
					</div>

					<div style={styles.inputContainer}>
						{React.Children.map(children, (child) => {
							if (child !== null && value !== undefined) {
								return React.cloneElement(child, {
									field: {
										value: value.includes(String(child.props.name)),
										name: child.props.name,
										onChange: this.handleChange,
										onBlur: this.handleBlur,
									},
								});
							}
						})}

						{touched && <InputFeedback error={error} />}
					</div>
				</div>
			</div>
		);
	}
}
